export { default as IconRestCardSkeleton } from './IconRestCardSkeleton'
